"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNT_NOT_SET_ERROR_MESSAGE = exports.IGNORED_ERROR_MESSAGES = exports.FIXEDI128_SCALING_FACTOR = exports.PERCENTAGE_GRANULARITY = void 0;
exports.PERCENTAGE_GRANULARITY = 3;
exports.FIXEDI128_SCALING_FACTOR = 18;
// IssueCompleted errors occur due to the vault having
// already auto-executed the issuance
exports.IGNORED_ERROR_MESSAGES = ["issue.IssueCompleted"];
exports.ACCOUNT_NOT_SET_ERROR_MESSAGE = "cannot sign transaction without setting account";
//# sourceMappingURL=constants.js.map